import { Divider } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { Divider as messages } from './messages';
import { theme } from '../../consts/theme';
import { useMeterModelSuggestionsStore } from '../../store/useMeterModelSuggestionsStore';

export const MeterModelDivider = () => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  return (
    <Divider style={{ color: theme.colors.dark, fontSize: 16, padding: '8px 0' }}>
      <FormattedMessage
        {...messages.meterModelName}
        values={{
          meterModelName: meterModelSuggestions?.meterModelName ?? intl.formatMessage(messages.unknownMeterModel),
        }}
      />
    </Divider>
  );
};
